import styled from 'styled-components';

// Components
import { Typography } from '../Typography';

/**
 * Contenido compartido por las DOS caras de un error: la pantalla suelta
 * (`pages/utils/Error`, el `errorElement` de la raíz del router) y el 404 que
 * se pinta DENTRO de la aplicación (`pages/utils/NotFound`). Lo mismo dicho
 * igual esté donde esté; lo único que cambia es el marco de alrededor.
 *
 * 🔴 **Sin tarjeta ni recuadro.** La primera versión iba dentro de una tarjeta
 * blanca con borde y sombra, y el usuario lo cazó al verla: «sale tipo modal,
 * sale raro». Tenía razón, y la guía lo respalda — un *empty state* (que es lo
 * que es un 404 dentro de una aplicación) se presenta como contenido centrado
 * sobre la propia página, no en un panel. La tarjeta añadía un segundo marco
 * encima del que ya pone la cabecera, y un recuadro flotante se lee como una
 * ventana modal: algo que se puede cerrar y que tapa lo que hay detrás. Aquí
 * no hay nada detrás.
 *
 * 🔴 Tampoco reusa `CredentialsLayout` (la foto aérea del login): esa imagen es
 * la de "estás fuera", y este error le puede salir a alguien con la sesión
 * perfectamente abierta.
 */
export const Content = styled.div`
  width: 100%;
  max-width: 44rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.spaces.l}rem;
`;

export const IconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled(Typography)`
  margin: 0;
`;

/** Motivo técnico del fallo — solo aparece cuando NO es un 404. */
export const Detail = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
  word-break: break-word;
`;
